"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListItem = void 0;
exports.findItemIndexByValue = findItemIndexByValue;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _requestAnimationFrameTimeout = require("request-animation-frame-timeout");
var _Divider = _interopRequireDefault(require("./Divider"));
var _dom = require("./utility/dom");
var _focus = require("./utility/focus");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // For some weird reason, in Chrome, `setTimeout()` would lag up to a second (or more) behind.
// Turns out, Chrome developers have deprecated `setTimeout()` API entirely without asking anyone.
// Replacing `setTimeout()` with `requestAnimationFrame()` can work around that Chrome bug.
// https://github.com/bvaughn/react-virtualized/issues/722
// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react["default"].PureComponent || _react["default"].Component;
var List = /*#__PURE__*/function (_PureComponent) {
  _inherits(List, _PureComponent);
  var _super = _createSuper(List);
  function List() {
    var _this;
    _classCallCheck(this, List);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      items: _this.props.items
    });
    // `ref`s of all items currently rendered.
    _defineProperty(_assertThisInitialized(_this), "itemRefs", []);
    // For select options list keyboard navigation via typing.
    _defineProperty(_assertThisInitialized(_this), "input", '');
    _defineProperty(_assertThisInitialized(_this), "getFocusedItemIndex", function () {
      return _this.state.focusedItemIndex;
    });
    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      return _this.focusItem();
    });
    // Deprecated method name.
    _defineProperty(_assertThisInitialized(_this), "unfocus", _this.clearFocus);
    // Focuses the list.
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var focusedItemIndex = _this.state.focusedItemIndex;
      if (focusedItemIndex !== undefined) {
        return _this.focusItem(focusedItemIndex);
      }
      _this.list.focus();
    });
    // Can be public API for programmatically focusing a certain `<List.Item/>`.
    _defineProperty(_assertThisInitialized(_this), "focusItem", function (focusedItemIndex) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
        onFocusItem = _this$props.onFocusItem,
        shouldFocus = _this$props.shouldFocus;
      if (onFocusItem) {
        onFocusItem(focusedItemIndex, options);
      }
      _this.setState({
        // Focus the item.
        focusedItemIndex: focusedItemIndex,
        // Store the focused item value.
        // This is used for cases like autocomplete
        // where the list of options changes but
        // the focused option stays focused.
        focusedItemValue: focusedItemIndex === undefined ? undefined : _this.getItemValue(focusedItemIndex)
      }, function () {
        // Actually focus the item.
        if (focusedItemIndex !== undefined) {
          if (shouldFocus && _this._isMounted) {
            if (!(0, _focus.focus)(_this.itemRefs[focusedItemIndex])) {
              console.error("<List.Item/> #".concat(focusedItemIndex + 1, "'s child component doesn't have a \".focus()\" method."));
            }
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _this$props2 = _this.props,
        onKeyDown = _this$props2.onKeyDown,
        children = _this$props2.children;
      var focusedItemIndex = _this.state.focusedItemIndex;
      if (onKeyDown) {
        onKeyDown(event);
      }
      if (event.defaultPrevented) {
        return;
      }
      if ((0, _dom.submitFormOnCtrlEnter)(event, _this.input)) {
        return;
      }
      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }
      if (_react["default"].Children.count(children) > 0) {
        switch (event.keyCode) {
          // "Up" arrow.
          // Select the previous item (if present).
          case 38:
            event.preventDefault();
            var previousIndex = _this.getPreviousFocusableItemIndex();
            if (previousIndex !== undefined) {
              _this.focusItem(previousIndex, {
                interaction: true
              });
            }
            return;

          // "Down" arrow.
          // Select the next item (if present).
          case 40:
            event.preventDefault();
            var nextIndex = _this.getNextFocusableItemIndex();
            if (nextIndex !== undefined) {
              _this.focusItem(nextIndex, {
                interaction: true
              });
            }
            return;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyPress", function (event) {
      var resetInputTimeout = _this.props.resetInputTimeout;
      var characters = event["char"] || String.fromCharCode(event.charCode);
      if (characters) {
        _this.input += characters;
        _this.onInput();
        (0, _requestAnimationFrameTimeout.clearTimeout)(_this.resetInputTimer);
        _this.resetInputTimer = (0, _requestAnimationFrameTimeout.setTimeout)(_this.resetInput, resetInputTimeout);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "resetInput", function () {
      return _this.input = '';
    });
    _defineProperty(_assertThisInitialized(_this), "isInputInProgress", function () {
      return _this.input !== '';
    });
    _defineProperty(_assertThisInitialized(_this), "onInputSpacebar", function () {
      if (_this.input) {
        _this.input += ' ';
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onItemFocus", function (event) {
      var expandable = _this.props.expandable;
      if (expandable) {
        return;
      }
      _this.onFocusIn();
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      var expandable = _this.props.expandable;
      if (expandable) {
        return;
      }
      (0, _requestAnimationFrameTimeout.clearTimeout)(_this.blurTimer);
      var result = (0, _focus.onBlur)(event, _this.onFocusOut, function () {
        return _this.list;
      });
      if (typeof result === 'number') {
        _this.blurTimer = result;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusIn", function () {
      var onFocusIn = _this.props.onFocusIn;
      if (onFocusIn) {
        onFocusIn();
      }
      _this.setState({
        isFocused: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusOut", function () {
      var value = _this.props.value;
      if (value === undefined) {
        _this.clearFocus();
      }
      _this.setState({
        isFocused: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "isFocusableItemIndex", function (index) {
      return _this.itemRefs[index] !== undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "isFocusableItem", function (item) {
      return !isDivider(item);
    });
    // `this.list` is also being accessed from `<ScrollableList/>`.
    _defineProperty(_assertThisInitialized(_this), "storeListNode", function (node) {
      return _this.list = node;
    });
    // Is only used by `<ScrollableList/>` so set `max-height` immediately,
    // without waiting for the next React render cycle.
    _defineProperty(_assertThisInitialized(_this), "getDOMNode", function () {
      return _this.list;
    });
    _defineProperty(_assertThisInitialized(_this), "storeItemRef", function (ref, i) {
      return _this.itemRefs[i] = ref;
    });
    return _this;
  }
  _createClass(List, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var highlightFirstItem = this.props.highlightFirstItem;
      if (highlightFirstItem) {
        this.focusItem(0);
      }
      this._isMounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props,
        value = _this$props3.value,
        items = _this$props3.items,
        children = _this$props3.children,
        highlightSelectedItem = _this$props3.highlightSelectedItem,
        highlightFirstItem = _this$props3.highlightFirstItem;

      // If `items` property is supplied
      // then it's used to detect "on items changed" event.
      if (prevState.items && prevState.items !== items) {
        this.setState({
          items: items
        });
        // `findItemIndexByValue()` must return `undefined` for "no such item".
        var selectedItemIndex = highlightSelectedItem ? findItemIndexByValue(value, children) : undefined;
        this.focusItem(selectedItemIndex === undefined ? highlightFirstItem ? 0 : undefined : selectedItemIndex);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      (0, _requestAnimationFrameTimeout.clearTimeout)(this.blurTimer);
      (0, _requestAnimationFrameTimeout.clearTimeout)(this.resetInputTimer);
    }
  }, {
    key: "chooseFocusedItem",
    value: function chooseFocusedItem() {
      var focusedItemIndex = this.state.focusedItemIndex;
      if (focusedItemIndex !== undefined) {
        var itemRef = this.itemRefs[focusedItemIndex];
        if (itemRef.click) {
          itemRef.click();
        }
      }
    }
  }, {
    key: "getFirstFocusableItemIndex",
    value: function getFirstFocusableItemIndex() {
      var i = 0;
      while (i < this.itemRefs.length) {
        if (this.itemRefs[i]) {
          return i;
        }
      }
    }
  }, {
    key: "getItemValue",
    value: function getItemValue(index) {
      var children = this.props.children;
      var item = _react["default"].Children.toArray(children)[index];
      return item.props.value;
    }
  }, {
    key: "onInput",
    value: function onInput() {
      var children = this.props.children;
      var index = findItemIndexByLabel(this.input, children);
      if (index !== undefined) {
        this.focusItem(index);
      }
    }
  }, {
    key: "getPreviousFocusableItemIndex",
    value:
    // Get the previous option (relative to the currently focused option)
    function getPreviousFocusableItemIndex() {
      var children = this.props.children;
      var focusedItemIndex = this.state.focusedItemIndex;
      if (focusedItemIndex === undefined) {
        focusedItemIndex = _react["default"].Children.count(children);
      }
      while (focusedItemIndex > 0) {
        focusedItemIndex--;
        if (this.isFocusableItemIndex(focusedItemIndex)) {
          return focusedItemIndex;
        }
      }
    }

    // Get the next option (relative to the currently focused option)
  }, {
    key: "getNextFocusableItemIndex",
    value: function getNextFocusableItemIndex() {
      var children = this.props.children;
      var focusedItemIndex = this.state.focusedItemIndex;
      if (focusedItemIndex === undefined) {
        focusedItemIndex = -1;
      }
      while (focusedItemIndex < _react["default"].Children.count(children) - 1) {
        focusedItemIndex++;
        if (this.isFocusableItemIndex(focusedItemIndex)) {
          return focusedItemIndex;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        id = _this$props4.id,
        expandable = _this$props4.expandable,
        disabled = _this$props4.disabled,
        tabbable = _this$props4.tabbable,
        value = _this$props4.value,
        hasOnChange = _this$props4.hasOnChange,
        onChange = _this$props4.onChange,
        onSelectItem = _this$props4.onSelectItem,
        highlightSelectedItem = _this$props4.highlightSelectedItem,
        createButtons = _this$props4.createButtons,
        className = _this$props4.className,
        style = _this$props4.style,
        children = _this$props4.children;
      var role = this.props.role;
      var _this$state = this.state,
        focusedItemIndex = _this$state.focusedItemIndex,
        isFocused = _this$state.isFocused;

      // ARIA (accessibility) roles info:
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      if (!role && (onChange || onSelectItem)) {
        role = 'listbox';
      }

      // if (this.props['aria-hidden']) {
      // 	role = undefined
      // }

      // `tabIndex={ -1 }` makes the `<ul/>` focusable.
      // So that `<Expandable/>` doesn't collapse on click inside it (top, bottom).

      return /*#__PURE__*/_react["default"].createElement("ul", {
        ref: this.storeListNode,
        id: id,
        role: role,
        "aria-label": this.props['aria-label'],
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-hidden": this.props['aria-hidden'],
        "aria-required": this.props['aria-required'],
        "aria-invalid": this.props['aria-invalid'],
        onFocus: this.onFocusIn,
        onKeyDown: this.onKeyDown,
        onKeyPress: this.onKeyPress,
        tabIndex: -1,
        style: style,
        className: (0, _classnames["default"])(className, 'rrui__outline', 'rrui__list', {
          'rrui__list--focus': isFocused
        })
      }, _react["default"].Children.map(children, function (item, i) {
        // Workaround for `react-hot-loader`.
        // https://github.com/gaearon/react-hot-loader#checking-element-types
        if (item.type.displayName !== 'ListItem') {
          throw new Error("Only <List.Item/>s can be placed inside a <List/> (and remove any whitespace).");
        }
        return /*#__PURE__*/_react["default"].cloneElement(item, {
          key: i,
          index: i,
          itemRef: _this2.isFocusableItem(item) ? _this2.storeItemRef : undefined,
          role: role === 'listbox' ? 'option' : item.props.role,
          focus: _this2.focusItem,
          focused: (expandable || isFocused) && focusedItemIndex === i,
          disabled: disabled || item.props.disabled,
          tabIndex: tabbable && (focusedItemIndex === undefined ? i === 0 : i === focusedItemIndex) ? 0 : -1,
          createButton: createButtons,
          isInputInProgress: _this2.isInputInProgress,
          onInputSpacebar: _this2.onInputSpacebar,
          onItemFocus: _this2.onItemFocus,
          onItemBlur: _this2.onBlur,
          onSelectItem: onChange || onSelectItem,
          hasOnSelectItem: hasOnChange,
          selectedItemValue: value,
          highlightSelectedItem: (onChange || onSelectItem) && highlightSelectedItem
        });
      }));
    }
  }]);
  return List;
}(PureComponent);
exports["default"] = List;
_defineProperty(List, "propTypes", {
  // (optional) HTML `id` attribute.
  // Can be used for WAI-ARIA stuff.
  // Example: `<input role="combobox"/>` with `aria-owns={listId}`.
  id: _propTypes["default"].string,
  value: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  // If a `<List/>` has `onChange` then it wraps `<List.Item/>`s with `<button/>`s.
  // The `onChange` added by `<ExpandableList/>` overrides the original `onChange`.
  // If there was no `onChange` — there will be one.
  // So to retain that info `hasOnChange` property is used as a workaround.
  // `undefined` means "ignore this property".
  hasOnChange: _propTypes["default"].bool,
  // If `items` property is supplied then it's used to
  // detect "on items changed" event in `getDerivedStateFromProps`.
  // It seems to be the only usage of the `items` property.
  items: _propTypes["default"].arrayOf(_propTypes["default"].object),
  // Legacy method, use `onChange` instead.
  onSelectItem: _propTypes["default"].func,
  highlightSelectedItem: _propTypes["default"].bool,
  onFocusIn: _propTypes["default"].func,
  onFocusItem: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  // ARIA `role` attribute.
  role: _propTypes["default"].string,
  // If a `<List/>` is `expandable`
  // then it won't be `.rrui__list:not(.rrui__list--focus)`.
  // `.rrui__list:not(.rrui__list--focus)` is only for standalone lists.
  expandable: _propTypes["default"].bool,
  // If `tabbable` is `true` (default behavior)
  // then the first item of the list
  // (or the last focused item of the list)
  // will be focused when the list gets focused.
  tabbable: _propTypes["default"].bool,
  // If `shouldFocus` is set to `false`
  // (which is not the default behavior)
  // then the list items won't actually
  // be `.focus()`ed (though they'll be
  // indicated as if they're focused).
  // This feature is used in `<Autocomplete/>`
  // that always keeps the actual focus on the `<input/>`.
  shouldFocus: _propTypes["default"].bool,
  // If `highlightFirstItem` is `true`
  // then by default the first item of the list
  // will be focused every time it's items change.
  // (and also when it's mounted)
  highlightFirstItem: _propTypes["default"].bool,
  createButtons: _propTypes["default"].bool,
  // For select options list keyboard navigation via typing.
  resetInputTimeout: _propTypes["default"].number
});
_defineProperty(List, "defaultProps", {
  tabbable: true,
  shouldFocus: true,
  highlightFirstItem: false,
  createButtons: true,
  highlightSelectedItem: true,
  resetInputTimeout: 1000
});
var ListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ListItem, _React$Component);
  var _super2 = _createSuper(ListItem);
  function ListItem() {
    var _this3;
    _classCallCheck(this, ListItem);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "onButtonKeyDown", function (event) {
      var _this3$props = _this3.props,
        isInputInProgress = _this3$props.isInputInProgress,
        onInputSpacebar = _this3$props.onInputSpacebar;
      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }
      switch (event.keyCode) {
        // "Spacebar".
        case 32:
          // If the user is currently typing.
          if (isInputInProgress()) {
            // Don't press the option button.
            event.preventDefault();
            // Append space character.
            onInputSpacebar();
          }
      }
    });
    _defineProperty(_assertThisInitialized(_this3), "onMouseDown", function (event) {
      var _this3$props2 = _this3.props,
        value = _this3$props2.value,
        index = _this3$props2.index,
        focus = _this3$props2.focus,
        children = _this3$props2.children;

      // If `<List.Item/>` child element gets wrapped in a `<button/>`
      // then call `onMouseDown` defined on the `<List.Item/>`.
      // If `<List.Item/>` child element doesn't get wrapped in a `<button/>`
      // then manually call `onMouseDown` defined on the `<List.Item/>` child element
      // because `onMouseDown` gets overridden for `<List.Item/>` child element.

      var onMouseDown = _this3.shouldCreateButton() ? _this3.props.onMouseDown : children.props.onMouseDown;

      // Without this Safari (both mobile and desktop)
      // won't select any item in an expanded list
      // because it will collapse the list immediately
      // on `mouseDown` due to `blur` event being fired.
      event.preventDefault();
      if (_this3.isSelectable()) {
        focus(index);
      }
      if (onMouseDown) {
        onMouseDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this3), "onFocus", function (event) {
      var _this3$props3 = _this3.props,
        focus = _this3$props3.focus,
        index = _this3$props3.index,
        onItemFocus = _this3$props3.onItemFocus,
        children = _this3$props3.children;

      // If `<List.Item/>` child element gets wrapped in a `<button/>`
      // then call `onFocus` defined on the `<List.Item/>`.
      // If `<List.Item/>` child element doesn't get wrapped in a `<button/>`
      // then manually call `onFocus` defined on the `<List.Item/>` child element
      // because `onFocus` gets overridden for `<List.Item/>` child element.

      var onFocus = _this3.shouldCreateButton() ? _this3.props.onFocus : children.props.onFocus;
      if (_this3.isSelectable()) {
        focus(index);
      }
      if (onFocus) {
        onFocus(event);
      }
      if (onItemFocus) {
        onItemFocus(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this3), "onBlur", function (event) {
      var _this3$props4 = _this3.props,
        onItemBlur = _this3$props4.onItemBlur,
        children = _this3$props4.children;

      // If `<List.Item/>` child element gets wrapped in a `<button/>`
      // then call `onBlur` defined on the `<List.Item/>`.
      // If `<List.Item/>` child element doesn't get wrapped in a `<button/>`
      // then manually call `onFocus` defined on the `<List.Item/>` child element
      // because `onBlur` gets overridden for `<List.Item/>` child element.

      var onBlur = _this3.shouldCreateButton() ? _this3.props.onBlur : children.props.onBlur;
      if (onBlur) {
        onBlur(event);
      }
      if (onItemBlur) {
        onItemBlur(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this3), "onClick", function (event) {
      var _this3$props5 = _this3.props,
        onClick = _this3$props5.onClick,
        onSelect = _this3$props5.onSelect,
        onSelectItem = _this3$props5.onSelectItem,
        index = _this3$props5.index,
        value = _this3$props5.value,
        children = _this3$props5.children;

      // If `<List.Item/>` child element gets wrapped in a `<button/>`
      // then call `onClick` defined on the `<List.Item/>`.
      // If `<List.Item/>` child element doesn't get wrapped in a `<button/>`
      // then manually call `onClick` defined on the `<List.Item/>` child element
      // because `onClick` gets overridden for `<List.Item/>` child element,
      // and also call `onClick` defined on the `<List.Item/>` (if any).

      if (onClick) {
        onClick(event);
      }
      if (!_this3.shouldCreateButton()) {
        // Since `onClick` gets overridden
        // for `<List.Item/>` child element
        // call its original `onClick` manually here.
        if (children.props.onClick) {
          children.props.onClick(event);
        }
      }
      if (_this3.isSelectable()) {
        if (onSelect) {
          onSelect(value, index);
        }
        if (onSelectItem) {
          onSelectItem(value, index);
        }
      }
    });
    // Perhaps this is called by `focus()` utility function.
    // Something like: `focus(this.itemRefs[i])`.
    _defineProperty(_assertThisInitialized(_this3), "focus", function () {
      var children = _this3.props.children;
      (0, _focus.focus)(_react["default"].Children.toArray(children)[0]);
    });
    _defineProperty(_assertThisInitialized(_this3), "storeRef", function (ref) {
      var _this3$props6 = _this3.props,
        itemRef = _this3$props6.itemRef,
        index = _this3$props6.index;
      if (itemRef) {
        itemRef(ref, index);
      }
    });
    return _this3;
  }
  _createClass(ListItem, [{
    key: "isSelectable",
    value: function isSelectable() {
      return isSelectableItem(this);
    }
  }, {
    key: "shouldCreateButton",
    value: function shouldCreateButton() {
      var _this$props5 = this.props,
        onClick = _this$props5.onClick,
        onSelect = _this$props5.onSelect,
        onSelectItem = _this$props5.onSelectItem,
        hasOnSelectItem = _this$props5.hasOnSelectItem,
        createButton = _this$props5.createButton,
        shouldCreateButton = _this$props5.shouldCreateButton;
      return this.isSelectable() && (onClick || onSelect || onSelectItem && (hasOnSelectItem === undefined ? true : hasOnSelectItem) && (createButton || shouldCreateButton));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        id = _this$props6.id,
        value = _this$props6.value,
        icon = _this$props6.icon,
        item = _this$props6.item,
        role = _this$props6.role,
        focused = _this$props6.focused,
        disabled = _this$props6.disabled,
        className = _this$props6.className,
        tabIndex = _this$props6.tabIndex,
        highlightSelectedItem = _this$props6.highlightSelectedItem,
        selectedItemValue = _this$props6.selectedItemValue,
        Component = _this$props6.component,
        children = _this$props6.children;

      // Throws an error for some weird reason.
      // React.Children.only(children)

      if (!Component) {
        if (_react["default"].Children.count(children) !== 1) {
          throw new Error("Each <List.Item/> must have a single child (and remove any whitespace).");
        }
      }
      var isSelected = this.shouldCreateButton() && value === selectedItemValue;
      var isDividerItem = !Component && isDivider(children);
      var properties = {
        ref: isDividerItem ? undefined : this.storeRef,
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        className: (0, _classnames["default"])(className, 'rrui__list__item', 'rrui__text-line', {
          /* `--focused` modifier is deprecated, use `--focus` instead. */
          'rrui__list__item--focused': focused,
          'rrui__list__item--focus': focused,
          'rrui__list__item--selected': isSelected && highlightSelectedItem,
          'rrui__list__item--disabled': disabled,
          'rrui__list__item--divider': isDividerItem
        })
      };
      if (id !== undefined) {
        properties.id = id;
      }
      if (tabIndex !== undefined) {
        properties.tabIndex = tabIndex;
      }
      var ItemComponent;
      var itemChildren;
      var label;
      if (this.shouldCreateButton()) {
        ItemComponent = 'button';
        label = getItemLabel(this);
        properties.type = 'button';
        properties.role = role;
        properties['aria-selected'] = isSelected;
        properties['aria-label'] = this.props.label || (Component ? undefined : typeof children !== 'string' && children && children.props ? children.props['aria-label'] : undefined);
        properties.disabled = disabled;
        properties.onKeyDown = this.onButtonKeyDown;
        properties.className = (0, _classnames["default"])(properties.className, 'rrui__button-reset', 'rrui__outline',
        // `.rrui__list__item--button` only sets the fixed `height`.
        !Component && 'rrui__list__item--button');
        itemChildren = Component ? /*#__PURE__*/_react["default"].createElement(Component, _extends({}, item, {
          selected: isSelected && highlightSelectedItem,
          focused: focused,
          disabled: disabled
        })) : renderListItemComponent({
          value: value,
          label: label,
          icon: icon,
          children: children
        });
      } else {
        // Don't overwrite `className` already defined on the `children`.
        properties.className = (0, _classnames["default"])(properties.className, children.props && children.props.className);
      }
      return /*#__PURE__*/_react["default"].createElement("li", {
        role: this.shouldCreateButton() || isDivider(children) ? 'presentation' : role,
        "aria-selected": this.shouldCreateButton() ? undefined : role && role !== 'presentation' ? isSelected : undefined,
        "aria-label": this.shouldCreateButton() ? undefined : label,
        className: "rrui__list__list-item"
      }, ItemComponent && /*#__PURE__*/_react["default"].createElement(ItemComponent, properties, itemChildren), !ItemComponent && /*#__PURE__*/_react["default"].cloneElement(children, properties));
    }
  }]);
  return ListItem;
}(_react["default"].Component); // Workaround for `react-hot-loader`.
// https://github.com/gaearon/react-hot-loader#checking-element-types
exports.ListItem = ListItem;
_defineProperty(ListItem, "propTypes", {
  // (optional) HTML `id` attribute.
  // Can be used for WAI-ARIA stuff.
  // Example: `<input role="combobox"/>` with `aria-activedescendant={focusedListItemId}`.
  id: _propTypes["default"].string,
  value: _propTypes["default"].any,
  index: _propTypes["default"].number,
  focused: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  // `onSelect` is deprecated, use `onClick` instead.
  onSelect: _propTypes["default"].func,
  onSelectItem: _propTypes["default"].func,
  // If a `<List/>` has `onChange` then it wraps `<List.Item/>`s with `<button/>`s.
  // The `onChange` added by `<ExpandableList/>` overrides the original `onChange`.
  // If there was no `onChange` — there will be one.
  // So to retain that info `hasOnChange` property is used as a workaround.
  // `undefined` means "ignore this property".
  hasOnSelectItem: _propTypes["default"].bool,
  selectedItemValue: _propTypes["default"].any,
  highlightSelectedItem: _propTypes["default"].bool,
  createButton: _propTypes["default"].bool,
  // Deprecated. Use `createButton` instead.
  shouldCreateButton: _propTypes["default"].bool,
  // The button won't be pressed on "Space" key
  // if the user is currently typing.
  isInputInProgress: _propTypes["default"].func,
  onInputSpacebar: _propTypes["default"].func
});
ListItem.displayName = 'ListItem';
List.Item = ListItem;

// Replace `itemChildren` array with `<React.Fragment/>`
// in some future when React >= 16.2.0 is common.
//
// <React.Fragment>
// 	{/* Icon. */}
// 	{icon &&
// 		<div className="rrui__list__item-icon">
// 			{ React.createElement(icon, { value, label }) }
// 		</div>
// 	}
// 	{/* Label (or content). */}
// 	{children}
// </React.Fragment>
function renderListItemComponent(_ref) {
  var value = _ref.value,
    label = _ref.label,
    icon = _ref.icon,
    children = _ref.children;
  // Label (or content).
  var itemChildren;
  if (typeof children === 'string') {
    // `text-overflow: ellipsis` doesn't work on `<button/>`s.
    // https://stackoverflow.com/questions/9905409/is-it-possible-to-use-text-overflow-ellipsis-on-a-button-element
    itemChildren = [/*#__PURE__*/_react["default"].createElement("span", {
      key: "label",
      className: "rrui__text-line"
    }, children)];
  } else {
    itemChildren = _react["default"].Children.toArray(children);
  }
  // Icon.
  if (icon) {
    itemChildren.unshift( /*#__PURE__*/_react["default"].createElement("span", {
      key: "icon",
      "aria-hidden": true,
      className: "rrui__list__item-icon"
    }, /*#__PURE__*/_react["default"].createElement(icon, {
      value: value,
      label: label
    })));
  }
  return itemChildren;
}
function haveItemsChanged(props, prevProps) {
  var items = _react["default"].Children.toArray(props.children);
  var prevItems = _react["default"].Children.toArray(prevProps.children);
  if (items.length !== prevItems.length) {
    return true;
  }
  var i = 0;
  while (i < items.length) {
    if (items[i].props.value !== prevItems[i].props.value) {
      return true;
    }
    i++;
  }
  return false;
}
function findItemIndexByValue(value, children) {
  var items = _react["default"].Children.toArray(children);
  var i = 0;
  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    var item = _step.value;
    if (isSelectableItem(item) && item.props.value === value) {
      return i;
    }
    i++;
  }
}
function findItemIndexByLabel(value, children) {
  var items = _react["default"].Children.toArray(children);
  var i = 0;
  for (var _iterator2 = _createForOfIteratorHelperLoose(items), _step2; !(_step2 = _iterator2()).done;) {
    var item = _step2.value;
    if (isSelectableItem(item)) {
      var itemLabel = getItemLabel(item);
      if (itemLabel && itemLabel.toLowerCase().indexOf(value.toLowerCase()) === 0) {
        return i;
      }
    }
    i++;
  }
}
function getItemLabel(item) {
  return item.props.label || (typeof item.props.children === 'string' ? item.props.children : undefined);
}
function isSelectableItem(item) {
  return item.props.component ? true : item.props.children && !isDivider(item.props.children);
}
function isDivider(element) {
  // Workaround for `react-hot-loader`.
  // https://github.com/gaearon/react-hot-loader#checking-element-types
  return element.type && element.type.displayName === 'Divider';
}
//# sourceMappingURL=List.js.map